import React from "react";
import { Grid } from "@culturehq/components";
import { Trans } from "app/utils";

import { useGet } from "app/hooks";

import EventStatus from "./analytics/EventStatus";
import EventSegment from "./analytics/EventSegment";
import EventHost from "./analytics/EventHost";
import LatestEvents from "./analytics/LatestEvents";
import EventFeedback from "./analytics/EventFeedback";
import EventRating from "./analytics/EventRating";
import DoughnutChart from "./analytics/DoughnutChart";
import "./analytics/styles.scss";

import ExportEvents from "./ExportEvents";

const Analytics = () => {
  const get = useGet("/analytics/events/stats");

  return (
    <div className="analytics clearfix">
      <div className="tile_main">
        <h3>
          <Trans>CULTURE ANALYTICS</Trans>
        </h3>
        <ExportEvents />
      </div>
      <EventStatus get={get} />
      <Grid>
        <Grid.Item md={6} lg={8}>
          <EventSegment />
        </Grid.Item>
        <Grid.Item md={6} lg={4}>
          <EventHost />
        </Grid.Item>
      </Grid>
      <Grid>
        <Grid.Item md={6} lg={8} className="table_wrap">
          <LatestEvents />
        </Grid.Item>
        <Grid.Item md={6} lg={4}>
          <DoughnutChart />
        </Grid.Item>
      </Grid>
      <Grid>
        <Grid.Item md={6} lg={8} className="table_wrap">
          <EventFeedback />
        </Grid.Item>
        <Grid.Item md={6} lg={4}>
          <EventRating get={get} />
        </Grid.Item>
      </Grid>
    </div>
  );
};

export default Analytics;
